import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppInfoComponent } from './app-info/app-info.component';
import { CustomInfoComponent } from './custom-info/custom-info.component';

@Component({
  selector: 'web-components-login-info-cards',
  templateUrl: './login-info-cards.component.html',
  styleUrls: ['./login-info-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, AppInfoComponent, CustomInfoComponent],
})
export class LoginInfoCardsComponent {
  public customInfoType: 'oco' | 'savings-plans' = new Date().getDate() % 2 === 0 ? 'oco' : 'savings-plans';
}
